export default __webpack_public_path__ + "static/media/binance.831e9dcc.png";